import { render, staticRenderFns } from "./TyopoytaPikanappain.vue?vue&type=template&id=14fab1c7&scoped=true&"
import script from "./TyopoytaPikanappain.vue?vue&type=script&lang=js&"
export * from "./TyopoytaPikanappain.vue?vue&type=script&lang=js&"
import style0 from "./TyopoytaPikanappain.vue?vue&type=style&index=0&id=14fab1c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fab1c7",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14fab1c7')) {
      api.createRecord('14fab1c7', component.options)
    } else {
      api.reload('14fab1c7', component.options)
    }
    module.hot.accept("./TyopoytaPikanappain.vue?vue&type=template&id=14fab1c7&scoped=true&", function () {
      api.rerender('14fab1c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TyopoytaPikanappain.vue"
export default component.exports